// fetchEventGroupings
import * as api from '../../api/maintenance/electronicCorrespondence';
import { makeApiActionCreatorV3 } from '../utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const namespace = 'MAINTENANCE/ELECTRONIC_CORRESPONDENCE';

export const FETCH_EVENT_GROUPINGS = createRequestTypes(
  `${namespace}/FETCH_EVENT_GROUPINGS`,
);

export const fetchEventGroupings = makeApiActionCreatorV3(
  api.fetchEventGroupings,
  FETCH_EVENT_GROUPINGS[START],
  FETCH_EVENT_GROUPINGS[SUCCESS],
  FETCH_EVENT_GROUPINGS[ERROR],
);

export const CREATE_EVENT_GROUPING = createRequestTypes(
  `${namespace}/CREATE_EVENT_GROUPING`,
);

export const createEventGrouping = makeApiActionCreatorV3(
  api.createEventGrouping,
  CREATE_EVENT_GROUPING[START],
  CREATE_EVENT_GROUPING[SUCCESS],
  CREATE_EVENT_GROUPING[ERROR],
);

export const UPDATE_EVENT_GROUPING = createRequestTypes(
  `${namespace}/UPDATE_EVENT_GROUPING`,
);

export const updateEventGrouping = makeApiActionCreatorV3(
  api.updateEventGrouping,
  UPDATE_EVENT_GROUPING[START],
  UPDATE_EVENT_GROUPING[SUCCESS],
  UPDATE_EVENT_GROUPING[ERROR],
);

export const DELETE_EVENT_GROUPING = createRequestTypes(
  `${namespace}/DELETE_EVENT_GROUPING`,
);

export const deleteEventGrouping = makeApiActionCreatorV3(
  api.deleteEventGrouping,
  DELETE_EVENT_GROUPING[START],
  DELETE_EVENT_GROUPING[SUCCESS],
  DELETE_EVENT_GROUPING[ERROR],
);

export const FETCH_EVENT_FORM_PUBLICATIONS = createRequestTypes(
  `${namespace}/FETCH_EVENT_FORM_PUBLICATIONS`,
);

export const fetchEventFormPublications = makeApiActionCreatorV3(
  api.fetchEventFormPublications,
  FETCH_EVENT_FORM_PUBLICATIONS[START],
  FETCH_EVENT_FORM_PUBLICATIONS[SUCCESS],
  FETCH_EVENT_FORM_PUBLICATIONS[ERROR],
);

export const SET_EVENT_FORM_GROUPING = createRequestTypes(
  `${namespace}/SET_EVENT_FORM_GROUPING`,
);

export const setGrouping = makeApiActionCreatorV3(
  api.setGrouping,
  SET_EVENT_FORM_GROUPING[START],
  SET_EVENT_FORM_GROUPING[SUCCESS],
  SET_EVENT_FORM_GROUPING[ERROR],
);

export const CLEAR_EVENT_FORM_GROUPING = createRequestTypes(
  `${namespace}/CLEAR_EVENT_FORM_GROUPING`,
);

export const clearGrouping = makeApiActionCreatorV3(
  api.clearGrouping,
  CLEAR_EVENT_FORM_GROUPING[START],
  CLEAR_EVENT_FORM_GROUPING[SUCCESS],
  CLEAR_EVENT_FORM_GROUPING[ERROR],
);

export const FETCH_SUPPORT_TICKET_TOPICS = createRequestTypes(
  `${namespace}/FETCH_SUPPORT_TICKET_TOPICS`,
);

export const fetchSupportTicketTopics = makeApiActionCreatorV3(
  api.fetchSupportTicketTopics,
  FETCH_SUPPORT_TICKET_TOPICS[START],
  FETCH_SUPPORT_TICKET_TOPICS[SUCCESS],
  FETCH_SUPPORT_TICKET_TOPICS[ERROR],
);

export const CREATE_SUPPORT_TICKET_TOPIC = createRequestTypes(
  `${namespace}/CREATE_SUPPORT_TICKET_TOPIC`,
);

export const createSupportTicketTopic = makeApiActionCreatorV3(
  api.createSupportTicketTopic,
  CREATE_SUPPORT_TICKET_TOPIC[START],
  CREATE_SUPPORT_TICKET_TOPIC[SUCCESS],
  CREATE_SUPPORT_TICKET_TOPIC[ERROR],
);

export const UPDATE_SUPPORT_TICKET_TOPIC = createRequestTypes(
  `${namespace}/UPDATE_SUPPORT_TICKET_TOPIC`,
);

export const updateSupportTicketTopic = makeApiActionCreatorV3(
  api.updateSupportTicketTopic,
  UPDATE_SUPPORT_TICKET_TOPIC[START],
  UPDATE_SUPPORT_TICKET_TOPIC[SUCCESS],
  UPDATE_SUPPORT_TICKET_TOPIC[ERROR],
);

export const DELETE_SUPPORT_TICKET_TOPIC = createRequestTypes(
  `${namespace}/DELETE_SUPPORT_TICKET_TOPIC`,
);

export const deleteSupportTicketTopic = makeApiActionCreatorV3(
  api.deleteSupportTicketTopic,
  DELETE_SUPPORT_TICKET_TOPIC[START],
  DELETE_SUPPORT_TICKET_TOPIC[SUCCESS],
  DELETE_SUPPORT_TICKET_TOPIC[ERROR],
);

export const FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS = createRequestTypes(
  `${namespace}/FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS`,
);

export const fetchSupportTicketTopicsFAQItems = makeApiActionCreatorV3(
  api.fetchSupportTicketTopicsFAQItems,
  FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS[START],
  FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS[SUCCESS],
  FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS[ERROR],
);

export const CREATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM = createRequestTypes(
  `${namespace}/CREATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM`,
);

export const createSupportTicketTopicFAQItem = makeApiActionCreatorV3(
  api.createSupportTicketTopicFAQItem,
  CREATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[START],
  CREATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[SUCCESS],
  CREATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[ERROR],
);

export const UPDATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM = createRequestTypes(
  `${namespace}/UPDATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM`,
);

export const updateSupportTicketTopicFAQItem = makeApiActionCreatorV3(
  api.updateSupportTicketTopicFAQItem,
  UPDATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[START],
  UPDATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[SUCCESS],
  UPDATE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[ERROR],
);

export const DELETE_SUPPORT_TICKET_TOPIC_FAQ_ITEM = createRequestTypes(
  `${namespace}/DELETE_SUPPORT_TICKET_TOPIC_FAQ_ITEM`,
);

export const deleteSupportTicketTopicFAQItem = makeApiActionCreatorV3(
  api.deleteSupportTicketTopicFAQItem,
  DELETE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[START],
  DELETE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[SUCCESS],
  DELETE_SUPPORT_TICKET_TOPIC_FAQ_ITEM[ERROR],
);
